<template>
  <div>
    <div class="box-save-minus">
      <div class="typeface-size" :style="{ fontSize: fontSize + 'px' }">
        第 {{ TrueNum }} 题 (判断题)
      </div>
      <div class="font-size-save-minus" v-if="false">
        <el-button size="small" @click="increaseFontSize">+</el-button>
        <span>{{ text }}</span>
        <el-button size="small" @click="decreaseFontSize">-</el-button>
      </div>
    </div>
    <!-- <div class="name">第 {{ TrueNum }} 题 (判断题)</div> -->
<!--    <div class="name" :style="{ fontSize: fontSize + 'px' }">{{ TrueContent }}</div>-->
    <div class="name" :style="{ fontSize: fontSize + 'px' }" v-html="TrueContent"></div>
    <el-radio-group v-model="radio" @change="handler">
      <el-radio
        :style="radioLabelStyle"
        v-for="(item, index) in TrueList"
        :key="index"
        :label="item.title"
        >{{ item.title }}. {{ item.answer }}</el-radio
      >
    </el-radio-group>
  </div>
</template>
<script>
export default {
  props: {
    fontSize: {
      type: Number,
      require: true,
      default: 16,
    },
    TrueNum: {
      type: Number,
      require: true,
      default: 0,
    },
    TrueContent: {
      type: String,
      require: true,
    },
    TrueList: {
      type: Array,
      require: true,
      default: [],
    },
    dataId: {
      type: String | Number,
      require: true,
    },
    currentAnswer: {
      type: String,
    },
  },
  watch: {
    currentAnswer: {
      handler(val) {
        if (!val) return;
        this.radio = val;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      radio: null,
      text: "字号",
      fontSize: 16, // 初始字体大小
    };
  },
  computed: {
    radioLabelStyle() {
      return { fontSize: this.fontSize + "px" };
    },
  },
  methods: {
    onSubmit() {
      return { No: this.TrueNum, answer: this.radio, dataId: this.dataId };
    },
    handler(e) {
      this.$emit("change", { No: this.TrueNum, answer: e, dataId: this.dataId });
    },
    increaseFontSize() {
      if (this.fontSize == 28) {
        this.$message({
          message: "已达到最大值",
          type: "warning",
        });
      } else {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize == 10) {
        this.$message({
          message: "已达到最小值",
          type: "warning",
        });
      } else {
        this.fontSize -= 2;
      }
    },
  },
};
</script>
<style scoped>
.el-radio-group {
  display: flex;
  flex-direction: column;
}
.el-radio {
  margin-top: 20px;
}
.el-radio >>> .el-radio__label {
  padding-left: 24px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  /* font-size: 24px; */
  font-size: inherit;
}
.el-radio >>> .el-radio__inner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid rgb(64, 112, 179);
}
.el-radio >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: rgb(64, 112, 179);
}

.name {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 30px;
}
.box-save-minus {
  height: 50px;
}
.typeface-size {
  float: left;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
}
.font-size-save-minus {
  font-family: 思源黑体;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/topicTrue.vue